import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import SubActionButton from "@quest_editor/components/Buttons/SubActionButton";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

type ProgressRow = {
  promotionId: string;
  promotionName: string;
  promotionType: string;
  questId: string;
  questName: string;
  progress: string;
  progressCurrent: number;
  progressTarget: number;
  scheduleStart: string;
  scheduleEnd: string;
};

const ProgressTableSection = ({
  pageRows,
  getTypeLabel,
}: {
  pageRows: ProgressRow[];
  getTypeLabel: (type: string) => string;
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <TableContainer sx={{ flex: 1, minHeight: 0, overflow: "auto" }}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>
              {t("quest_progress_list.table.header.promotion_id")}
            </TableCell>
            <TableCell>
              {t("quest_progress_list.table.header.promotion_name")}
            </TableCell>
            <TableCell>
              {t("quest_progress_list.table.header.quest_id")}
            </TableCell>
            <TableCell>
              {t("quest_progress_list.table.header.quest_name")}
            </TableCell>
            <TableCell>
              {t("quest_progress_list.table.header.type")}
            </TableCell>
            <TableCell>
              {t("quest_progress_list.table.header.progress")}
            </TableCell>
            <TableCell>
              {t("quest_progress_list.table.header.schedule")}
            </TableCell>
            <TableCell>
              {t("quest_progress_list.table.header.actions")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {pageRows.length === 0 ? (
            <TableRow>
              <TableCell colSpan={8} align="center">
                <Typography color="text.secondary" py={4}>
                  {t("common.label.no_data")}
                </Typography>
              </TableCell>
            </TableRow>
          ) : (
            pageRows.map((row, index) => (
              <TableRow key={index} hover>
                <TableCell>
                  <Typography color="text.secondary">
                    {row.promotionId}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color="text.secondary">
                    {row.promotionName}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color="text.secondary">
                    {row.questId}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color="text.secondary">
                    {row.questName}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color="text.secondary">
                    {getTypeLabel(row.promotionType)}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    color={
                      row.progressCurrent >= row.progressTarget
                        ? "success.main"
                        : "text.secondary"
                    }
                    fontWeight={
                      row.progressCurrent >= row.progressTarget
                        ? "bold"
                        : "normal"
                    }
                  >
                    {row.progress}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color="text.secondary">
                    {row.scheduleStart || row.scheduleEnd
                      ? t("quest_progress_list.table.schedule_label", {
                          start: row.scheduleStart
                            ? dayjs(row.scheduleStart).format("YYYY/MM/DD")
                            : "-",
                          end: row.scheduleEnd
                            ? dayjs(row.scheduleEnd).format("YYYY/MM/DD")
                            : "-",
                        })
                      : "-"}
                  </Typography>
                </TableCell>
                <TableCell>
                  <SubActionButton
                    size="small"
                    component={Link}
                    to={`/quest_editor/promotion/${row.promotionId}`}
                  >
                    {t("quest_progress_list.button.detail")}
                  </SubActionButton>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ProgressTableSection;
